const updateNexitaCartCountdown = () => {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Paris',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(new Date());
  const values = Object.fromEntries(parts.map(({ type, value }) => [type, value]));
  const elapsed = Number(values.hour) * 3600 + Number(values.minute) * 60 + Number(values.second);
  const remaining = Math.max(0, 86399 - elapsed);
  const hours = String(Math.floor(remaining / 3600)).padStart(2, '0');
  const minutes = String(Math.floor((remaining % 3600) / 60)).padStart(2, '0');
  const seconds = String(remaining % 60).padStart(2, '0');

  document.querySelectorAll('[data-nexita-cart-countdown]').forEach((element) => {
    element.textContent = `${hours}:${minutes}:${seconds}`;
  });
};

updateNexitaCartCountdown();
window.setInterval(updateNexitaCartCountdown, 1000);
